var _rect, _path, _rect2, _rect3, _rect4, _rect5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftworksLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 160,
    height: 160,
    rx: 30,
    fill: "#4A5568"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 100 L90 120 L130 70",
    stroke: "#60A5FA",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 60,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 40,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 50,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 150,
    width: 45,
    height: 4,
    rx: 2,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 120,
    fontFamily: "'Nunito Sans', system-ui, -apple-system, sans-serif",
    fontSize: 72,
    fontWeight: 800,
    fill: "#4A5568"
  }, "\n    SHIFTWORKS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftworksLogo);
export default __webpack_public_path__ + "static/media/shiftworks-logo.94c0f8211e22122f50c69c3b31ebd48e.svg";
export { ForwardRef as ReactComponent };